import {EstabelecimentoModel} from '../../estabelecimento.model';
import {Util} from '../../../../utils/util';
import * as moment from 'moment';
import {EstabSevicoModel, IEndeSevico} from '../../caracterizacao/estab-sevico.model';

export class RascIdentificacaoEnderecoComplementarModel {

    bairro: string;
    cep: string;
    codigoMunicipioIBGE: string;
    codigoUf: string;
    codigosServicosEspecializados: [];
    complemento: string;
    dataAtivacao: any;
    dataDesativacao: any;
    dddTelefone: string;
    identificacao: string;
    logradouro: string;
    nomeMunicipio: string;
    numeroEndereco: string;
    siglaUf: string;
    telefone: string;

    constructor(estabelecimento: EstabelecimentoModel) {
        const enderecosComplementares = estabelecimento.identificacao.enderecosComplementares;
        // console.log('enderecosComplementares: ', enderecosComplementares);
        this.bairro = enderecosComplementares ? enderecosComplementares.bairro : '';
        this.cep = enderecosComplementares ? Util.somenteNumeros(enderecosComplementares.cep) : '';
        this.codigoMunicipioIBGE = enderecosComplementares ? enderecosComplementares.codigoMunicipioIBGE : '';
        this.numeroEndereco = enderecosComplementares ? enderecosComplementares.numeroEndereco : '';
        this.complemento = enderecosComplementares ? enderecosComplementares.complemento : '';
        this.dataAtivacao = enderecosComplementares ? moment(enderecosComplementares.dataAtivacao, 'DD/MM/YYYY').toDate() : '';
        this.dataDesativacao = enderecosComplementares ? moment(enderecosComplementares.dataDesativacao, 'DD/MM/YYYY').toDate() : '';
        this.identificacao = enderecosComplementares ? enderecosComplementares.identificacao : '';
        this.logradouro = enderecosComplementares ? enderecosComplementares.logradouro : '';
        this.nomeMunicipio = enderecosComplementares ? enderecosComplementares.nomeMunicipio : '';
        this.numeroEndereco = enderecosComplementares ? enderecosComplementares.numeroEndereco : '';
        this.siglaUf = enderecosComplementares ? enderecosComplementares.siglaUf : '';
        this.codigoUf = enderecosComplementares ? enderecosComplementares.codigoUf : '';
        this.nomeMunicipio = enderecosComplementares ? enderecosComplementares.nomeMunicipio : '';
        // tslint:disable-next-line:max-line-length
        this.dddTelefone = enderecosComplementares && enderecosComplementares.telefone ? Util.somenteNumeros(enderecosComplementares.telefone.substring(0, 3)) : '';
        // tslint:disable-next-line:max-line-length
        this.telefone = enderecosComplementares && enderecosComplementares.telefone ? Util.somenteNumeros(enderecosComplementares.telefone.substring(3, 15)) : '';
        const lista: [] = [];
        if (enderecosComplementares && enderecosComplementares.servicosVinculados) {
            enderecosComplementares.servicosVinculados.forEach((item) => {
                // @ts-ignore
                if (Number(item.idServico)) {
                    // @ts-ignore
                    lista.push(item.idServico);
                }
            });
        }
        this.codigosServicosEspecializados = lista;
    }

    private preparaServicos(servicos: EstabSevicoModel[]): IEndeSevico[] {
        const lista: IEndeSevico[] = [];
        if (servicos && servicos.length > 0) {
            servicos.forEach((item) => {
                // @ts-ignore
                lista.push(item.idServico);
            });
        }
        return lista;
    }
}
